import '@ebay/skin/marketsans';
import '@ebay/skin/core';
import '@ebay/skin/typography';

export default class {}
